const STATES_DEFAULT = "/en/forms/options.json";

export default async function fetchStates({
  root,
  baseUrl,
  params = {},
  signal,
} = {}) {
  const ds = (root && root.dataset) || {};
  const base = ds.statesUrl || baseUrl || STATES_DEFAULT;
  const url = buildStatesUrl(base, params, ds);

  const res = await fetch(url.toString(), {
    signal,
    headers: { Accept: "application/json" },
  });

  if (!res.ok) {
    throw new Error(`HTTP ${res.status} fetching states`);
  }

  const json = await res.json();
  const rows = Array.isArray(json?.data) ? json.data : [];

  const options = rows
    .map((row) => {
      const text = String(row?.Option ?? "").trim();
      const value = String(row?.Value ?? "").trim();
      if (!text) return null;
      return { text, value: value || text };
    })
    .filter(Boolean)
    .sort((a, b) => a.text.localeCompare(b.text));

  return { options };
}

function buildStatesUrl(base, params = {}) {
  const url = isAbsoluteUrl(base)
    ? new URL(base)
    : new URL(base, window.location.origin);

  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    url.searchParams.set(k, String(v));
  });

  return url;
}
function isAbsoluteUrl(str) {
  try {
    new URL(str);
    return true;
  } catch {
    return false;
  }
}
